export const getUnrealizedPotential = state => state?.unrealizedPotential?.potential;
export const getUnrealizedPotentialSupported = state => state?.unrealizedPotential?.supported;
export const getUnrealizedPotentialDescriptor = state => state?.unrealizedPotential?.descriptor;
export const getUnrealizedPotentialFetching = state => state?.unrealizedPotential?.isUnrealizedPotentialFetching;
export const getUnrealizedPotentialSuccess = state => state?.unrealizedPotential?.isUnrealizedPotentialSuccess;
export const getUnrealizedPotentialModelSettings = state => state?.unrealizedPotential?.modelSettings;
export const getUnrealizedPotentialWarnings = state => state?.unrealizedPotential?.warnings || {};
